import React from "react";

import { Box } from "@mui/material";
import PropTypes from "prop-types";
import Footer from "Components/Footer";
// import Navbar from "../Navbar";

const Layout = ({ children }) => {
  return (
    <>
      <Box
        sx={{
          display: {
            xs: "none",
            md: "block",
            position: "sticky",
            top: 0,
            zIndex: 10,
          },
        }}
      >
        {/* <Navbar /> */}
      </Box>

      <main style={{ minHeight: "100vh" }}>{children}</main>

      <Footer />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
